import { useState } from "react";
import PdfURLContext from "./pdfURLContext";

export const PdfURLProvider = ({ children }) => {
  const [url, setUrl] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [showTab, setShowTab] = useState(1);

  return (
    <PdfURLContext.Provider
      value={{ pageNo, setPageNo, url, setUrl, showTab, setShowTab }}
    >
      {children}
    </PdfURLContext.Provider>
  );
};
